import {daysBetween, isPlanActive} from "../../../helpers/helpers";
import React from "react";

const StatusItem = ({expirationDate, doesNotExpire, hasActiveFreeTrial,
                        isDemoResellerAccount = false, freeTrialExpirationDate}) => {
    if (doesNotExpire) {
        return (
            <div className={'status-item status-active'} data-testid={'activeStatusItem'}>
                {i18n.payments.statusActive}
            </div>
        );
    }

    if (hasActiveFreeTrial) {
        return (
            <div className={'status-item status-active'} data-testid={'activeFreeTrialStatusItem'}>
                {i18n.payments.statusActiveFreeTrial}
            </div>
        );
    }

    if (isDemoResellerAccount) {
        return (
            <div className={'status-item'} data-testid={'demoResellerStatusItem'}>
                {i18n.payments.demoResellerAccess}
            </div>
        );
    }

    const hasActivePlan = isPlanActive(expirationDate);
    const daysUntilExpired = daysBetween(new Date(), new Date(expirationDate));

    if (hasActivePlan && daysUntilExpired >= 7) {
        return (
            <div className={'status-item status-active'} data-testid={'activeStatusItem'}>
                {i18n.payments.statusActive}
            </div>
        );
    } else if (hasActivePlan && daysUntilExpired < 7 && daysUntilExpired >= 0) {
        return (
            <div className={'status-item status-about-to-expire'} data-testid={'aboutToExpireStatusItem'}>
                {i18n.payments.statusActiveAboutToExpire}
            </div>
        );
    } else if (expirationDate) {
        return (
            <div className={'status-item status-expired'} data-testid={'expiredStatusItem'}>
                {i18n.payments.statusExpired}
            </div>
        );
    }

    return <></>;
};

export default StatusItem;